import { CURRENCIES } from '@/common/constants/currencies';
import { GboxAnswer } from '@/tms/reports/_models/reports.model';

export interface ScanCostHints {
	amount: number | null;
	currency: string | null;
}

const CURRENCY_QUESTION_NEEDLE = 'wybor waluty';
const AMOUNT_QUESTION_NEEDLE = 'podaj kwot';

const DIACRITICS: Readonly<Record<string, string>> = {
	ą: 'a',
	ć: 'c',
	ę: 'e',
	ł: 'l',
	ń: 'n',
	ó: 'o',
	ś: 's',
	ź: 'z',
	ż: 'z',
};

const normalize = (value: string | null | undefined): string => {
	if (!value) {
		return '';
	}
	return value
		.replace(/[–—−]/g, '-')
		.toLowerCase()
		.replace(/[ąćęłńóśźż]/g, (char) => DIACRITICS[char] ?? char)
		.replace(/\s+/g, ' ')
		.trim();
};

const parseAmount = (raw: string | null | undefined): number | null => {
	if (!raw) {
		return null;
	}
	const cleaned = raw.replace(/[^0-9,.-]/g, '').replace(',', '.');
	if (cleaned === '') {
		return null;
	}
	const value = Number.parseFloat(cleaned);
	return Number.isFinite(value) && value > 0 ? value : null;
};

const parseCurrency = (raw: string | null | undefined): string | null => {
	if (!raw) {
		return null;
	}
	const known = new Set(CURRENCIES.map((option) => option.value));
	const tokens = raw.toUpperCase().match(/[A-Z]{3}/g) ?? [];
	return tokens.find((token) => known.has(token)) ?? null;
};

export function extractScanCostHints(answers: GboxAnswer[] | null | undefined): ScanCostHints {
	let amount: number | null = null;
	let currency: string | null = null;

	for (const answer of answers ?? []) {
		const question = normalize(answer.questionText);
		if (question === '') {
			continue;
		}
		if (currency === null && question.includes(CURRENCY_QUESTION_NEEDLE)) {
			currency = parseCurrency(answer.answer);
		} else if (amount === null && question.includes(AMOUNT_QUESTION_NEEDLE)) {
			amount = parseAmount(answer.answer);
		}
	}

	return { amount, currency };
}
